module.exports = __webpack_public_path__ + "static/media/general-chemistry.3a1b0e55.svg";